var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attr-select"},[_c('el-select',{model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},_vm._l((_vm.selectShopOptions),function(item){return _c('el-option',{key:+item.rule_id,attrs:{"label":item.rule_title,"value":+item.rule_id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }